import * as React from 'react';
import { actions } from 'react-redux-form';
import { Card, Form, Notification, Loader } from '../';
import { find } from 'lodash';
import FIELDS from '../../data/fields';

interface Props {
  handleSubmit: (data) => void;
  isRequesting: boolean;
  settings: any;
  error: string | boolean;
}

class SettingsForm extends React.Component<Props> {
  render() {
    if (!this.props.settings) {
      return <Loader fullwidth />;
    }
    return (
      <div>
        <Card>
          <Form
            type="settings_form"
            buttonText="Update Settings"
            disabled={this.props.isRequesting}
            handleSubmit={(data) => this.props.handleSubmit(data)}
            fields={FIELDS.settings}
            getDispatch={(dispatch) => {
              const setSetting = (field: string) => {
                const setting: any = find(this.props.settings, { field }) || {
                  value: 0,
                };
                return dispatch(
                  actions.change(`settings_form.${field}`, setting.value),
                );
              };
              [
                'default_responsibility_amount',
                'terms_conditions',
                'price_per_mile',
                'security_cost',
              ].forEach(setSetting);
            }}
          />
        </Card>
        {this.props.error && (
          <Notification type="danger">{this.props.error}</Notification>
        )}
      </div>
    );
  }
}

export default SettingsForm;
